import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=20e599ca&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e599ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e599ca')) {
      api.createRecord('20e599ca', component.options)
    } else {
      api.reload('20e599ca', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=20e599ca&scoped=true&", function () {
      api.rerender('20e599ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/seikyu/detail.vue"
export default component.exports